export enum UserTypes {
    EnterpriseOwner = 'EnterpriseOwner',
    EnterpriseMember = 'EnterpriseMember',
    EnterpriseOfficer = 'EnterpriseOfficer'
}
